import React from 'react';
import DisplayItPerformance from './display-it-performance';
import { destandard } from '../../../utils/commonFunctions';
import './style.css';

const DisplayItPerformances = (props) => {
  const { performances } = props;

  return (
    <div>
      {
        performances.map((value, key) => {
          const performance = destandard({ ...value });
          return (
            performance.display_objectives && performance.display_objectives.length && (
              <DisplayItPerformance {...performance} key={key} index={key} />
            )
          ) || false;
        })
      }
    </div>
  );
};

export default DisplayItPerformances;



// WEBPACK FOOTER //
// ./src/components/store-performance/display-it/index.jsx